import * as types from './types';
import * as htmlSanitize from 'src/helpers/htmlSanitize';

export const state = {
  list: {
    steps: [],
    submissions: [],
    submissions_total: 0,
    is_last_page: true,
  },
  quizId: 0,
  page: 1,
  dateFrom: null,
  dateTo: null,
  reportExportLimit: process.env.REPORT_MAX_LIMIT,
  email: '',
};

export const mutations = {
  [types.REPORT_SET_ANSWERS](state, data) {
    const excludedKindsOnResult = ['thanks', 'redirect'];
    const filteredSteps = data.steps.filter(step => !excludedKindsOnResult.includes(step.kind));

    data.steps = htmlSanitize.stepList(filteredSteps);

    state.list = data;
  },
  [types.REPORT_SET_QUIZ_ID](state, quizId) {
    state.quizId = quizId;
  },
  [types.REPORT_SET_PAGE](state, page) {
    state.page = page;
  },
  [types.REPORT_SET_DATE_FROM](state, dateFrom) {
    state.dateFrom = dateFrom;
  },
  [types.REPORT_SET_DATE_TO](state, dateTo) {
    state.dateTo = dateTo;
  },
  [types.REPORT_RESET_STATE](state) {
    state.list = {};
    state.quizId = 0;
    state.page = 1;
    state.dateFrom = null;
    state.dateTo = null;
  },
  [types.REPORT_SET_EXPORT_EMAIL](state, email) {
    state.email = email;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/tableData/mutations.js
 **/